import { Pipe, PipeTransform } from '@angular/core';
import { PerareFeature } from '../../../../shared/services/api/listing-api.types';
import {Feature, featureCollection, FeatureCollection, midpoint, Point} from '@turf/turf';

@Pipe({
  name: 'polygonToPoints',
  standalone: true,
})
export class PolygonToPointsPipe implements PipeTransform {
  transform(features: PerareFeature[]): FeatureCollection<Point> {
    const points = features.reduce((acc, current) => {
      // Обрабатываем только полигоны
      const geometry = current.geometry as any;
      if (geometry.type !== 'Polygon') {
        return acc;
      }
      const polygonPoints = geometry.coordinates[0].map((position: any) => {
        return midpoint(position, position);
      });

      return [...acc, ...polygonPoints];
    }, [] as Feature<Point>[]);

    return featureCollection(points);
  }
}
